// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"BurgerMenu_buttonsContainer__2WEcr","burgerButton":"BurgerMenu_burgerButton__1wLzA","notAllowedCursor":"BurgerMenu_notAllowedCursor__2LUAt"};